/**
 * @author Srinivas
 * @license Proprietary
 * @copyright Whyable technologies. All rights reserved.
 */

import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FileValidationErrors, UploaderService} from './uploader.service';

@Component({
  selector: 'app-why-file-uploader',
  template: `
    <div class="uploader-container">
      <div *ngIf="imageCrop; else preview" class="crop-container">
        <!-- TODO: Crop Image here -->
        <p> Crop</p>
      </div>
      <ng-template #preview>
        <div *ngIf="!disabled" class="preview-container">
          <div *ngIf="selectedFile || imgPath !==''; else select_placeholder"
               class="img-preview">
            <app-why-lib-file-viewer *ngIf="selectedFile" class="file-viewer"
                                     [file]="selectedFile"></app-why-lib-file-viewer>

            <img *ngIf="!imgPath.includes('undefined') && selectedFile === undefined"
                 alt="uploaded image" [src]="imgPath"
                 class="image-viewer"
                 default="./assets/img/default-img.svg"
                 (click)="change(input)"/>
          </div>


          <ng-template #select_placeholder>
          </ng-template>

          <ng-template #tipContent>Change image</ng-template>

          <input class="uploader-input" type="file" #input (change)="onFile($event)"/>

          <!--<div class="choose-file" *ngIf="(imgPath !=='' || !imgPath) && !selectedFile">
            <div class="button-capsule">
              <button (click)="change(input)">
              </button>
            </div>
          </div>-->

          <div *ngIf="allowRetry && uploadFailed" class="retry-overlay">
            <button (click)="upload()">Retry</button>
            <button (click)="change(input)">Change</button>
          </div>
        </div>

        <div *ngIf="disabled">
          <img class="image-viewer" [src]="imgPath" alt="image"
               default="./assets/img/default-img.svg">
        </div>
      </ng-template>

    </div>
  `,
  styleUrls: [
    'uploader.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class UploaderComponent implements OnInit {
  //
  @Input() allowRetry = false;
  @Input() uploadUrl: string;
  @Input() maxFileSize: number;
  @Input() fileType: string[];
  @Input() fileFormats: string[];
  @Input() isFileUploaded = false;
  @Input() disabled = false;
  @Input() imgPath: string;

  @Output() isFileUploadedChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() isUploadDone: EventEmitter<any> = new EventEmitter<any>();
  @Output() isValidationError: EventEmitter<any> = new EventEmitter<any>();
  @Output() isFileUploadInProgress: EventEmitter<boolean> = new EventEmitter<boolean>();
  placeholderImage = false;
  selectedFile: File;
  uploadFailed = false;
  imageCrop = false;

  // private el: HTMLElement;
  // @ViewChild('el') tooltip: ElementRef<any>;

  constructor(protected uploader: UploaderService) {
  }

  ngOnInit(): void {
    this.isFileUploaded = false;
    this.placeholderImage = this.imgPath !== '';
  }

  /**
   * Get the file here
   * param $event
   */
  upload(): any {
    if (!this.selectedFile) {
      return;
    }
    this.isFileUploadInProgress.emit(true);
    return Promise.resolve(this.selectedFile)
      .then(file => this.uploader.uploadFile(this.uploadUrl, {file, name: 'file'})
        .toPromise()
        .then(this.handleSuccessful.bind(this))
        .catch(err => {
          console.error(err, 'SIZE_LIMIT_INVALID_EXCEEDED');
          this.isValidationError.emit(err);
          this.uploadFailed = true;
          throw err.error.error.code;
        }))
      .catch(this.errorHandler.bind(this));
  }

  /**
   * On file changes
   * param $event
   */
  onFile($event): any {
    const file: any = this.selectedFile = $event.target.files[0];
    $event.target.value = '';
    this.isFileUploadedChange.next(false);

    // Validate file
    Promise.resolve(this.uploader.validateFile(file, {
      maxSize: this.maxFileSize
      , type: this.fileType
      , format: this.fileFormats
    }))
      .catch((err) => {
        console.error(err, 'err');
        this.selectedFile = undefined;
        throw err;
      })

      // .then((file: File) => this.crop({ target: { files: [file] }}))
      // tslint:disable-next-line:no-shadowed-variable
      .then((fileObj: File) => {
        this.selectedFile = fileObj;
      })
      // Upload file
      .then(this.upload.bind(this))
      .catch((error) => {
        this.errorHandler.bind(error);
        console.error(error);
        this.isValidationError.emit(error);
      });
  }

  /**
   * Handle validation errors
   */
  private errorHandler(code): { code; title; message } {
    let error = {
      code: 'UNKNOWN_VALIDATION_ERROR',
      title: 'Unknown validation error',
      message: 'Unknown validation error'
    };

    switch (code) {
      case (FileValidationErrors.invalidSize || FileValidationErrors.sizeLimitInvalidExceeded):
        error = {
          code,
          title: 'Invalid file size',
          message: 'File should be less the ' + (this.maxFileSize / 1024) + 'KB'
        };
        break;
      case FileValidationErrors.invalidType:
        error = {
          code,
          title: 'Invalid file type',
          message: `Select any file type of ( ${this.fileType.join(', ')} )`,
        };
        break;
      case FileValidationErrors.invalidFormat:
        error = {
          code,
          title: 'Invalid file format',
          message: `Select any file format of ( ${this.fileFormats.join(', ')} )`,
        };
        break;
      default:
        return;
    }

    this.isValidationError.emit(error);
    return error;
  }

  /**
   * Handle upload successful
   */
  private handleSuccessful(res: any): any {
    this.uploadFailed = false;
    this.isFileUploadedChange.next(true);
    this.isUploadDone.emit(res);

    return res;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  change(input: HTMLInputElement): void {
    input.click();
    input.value = '';
    this.uploadFailed = false;
    this.selectedFile = undefined;
    this.isFileUploadedChange.emit(false);
  }

  /*crop($event: any): Promise<File> {
    return new Promise<any>((resolve, reject) => {
      this.image_crop = {
        event: $event,
        onDone: (file) => {
          this.image_crop = undefined;

          resolve(file);
        }
      };
    });
  }*/


}
